<template>
  <!-- Very unusual margin, but that's what the mockup shows -->
  <app-empty-state
    v-if="isRootFolder"
    class="mt-12"
    module="documents"
    translation-key-prefix="project.documents.DocumentsEmptyState"
  />
  <div
    v-else
    class="d-flex flex-column"
    data-locator="empty-state"
  >
    <!-- The min-height is based on the mockup, to force a vertical align -->
    <v-card class="d-flex flex-column align-center justify-center text-center" min-height="200">
      <app-icon-ds icon="file-lines" size="xl" class="mb-5" />
      <h3 class="mb-2" data-locator="empty-state-title">
        {{
          this.isRecentFolder
          ? $t('project.documents.DocumentsEmptyState.noRecentFilesTitle')
          : $t('project.documents.DocumentsEmptyState.noTodoFilesTitle')
        }}
      </h3>
      <p
        class="text--small"
        data-locator="empty-state-text"
      >{{
          this.isRecentFolder
        ? $t('project.documents.DocumentsEmptyState.noFilesText')
        : $t('project.documents.DocumentsEmptyState.noTodoFilesText')
      }}</p>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { ROOT_FOLDER, RECENT_FOLDER } from '@/project/documents/constants/special-folders'

export default {
  name: 'DocumentsEmptyState',
  data () {
    return {
      ROOT_FOLDER,
      RECENT_FOLDER,
    }
  },
  computed: {
    ...mapState('documents', ['paginatedDocumentsCurrentFolderId']),
    isRootFolder () {
      return this.paginatedDocumentsCurrentFolderId === ROOT_FOLDER.id
    },
    isRecentFolder () {
      return this.paginatedDocumentsCurrentFolderId === RECENT_FOLDER.id
    },
  },
}
</script>
